/*
 * Searchbar component utilizing antd
 * Documentation at https://ant.design/
 */
import React, { Component } from 'react';
import { Col, Input, Row, Select, Typography } from 'antd';

const Option = Select.Option;
const InputGroup = Input.Group;
const Text = Typography.Text;

/*
 * Settings parameters
 */
class Settings extends Component {
    /*
     * Handle change events for reference frames and annotations
     */
    handleChange = ( key, value ) => {
        this.props.onChange( key , value );
    }

    render() {
        const { reference_frame, processing, annotations } = this.props.params;

        return (
            <Row gutter={ 0 } type="flex" justify="center">
                <Col span = { 6 }>
                    <Text type="secondary">Reference Frame</Text>
                </Col>
                <Col span = { 6 }>
                    <Text type="secondary">Post Processing</Text>
                </Col>
                <Col span = { 12 }>
                    <Text type="secondary">Other Options</Text>
                </Col>
                <Col span = { 24 }>
                    <InputGroup compact>
                        <Select
                            value = { reference_frame }
                            style = {{ width : '25%' }}
                            onChange = { ( value ) => this.handleChange( 'reference_frame', value ) }
                        >
                            <Option value="IGS08">IGS08</Option>
                            <Option value="NAM08">NAM08</Option>
                        </Select>
                        <Select
                            value = { processing }
                            style = {{ width : '25%' }}
                            onChange = { ( value ) => this.handleChange( 'processing', value ) }
                        >
                            <Option value="uncleaned">Raw</Option>
                            <Option value="cleaned">Cleaned</Option>
                        </Select>
                        <Select
                            value = { annotations }
                            mode = "multiple"
                            onChange = { ( value ) => this.handleChange( 'annotations', value ) }
                            placeholder = "Select annotations"
                            style = {{ width : '50%' }}
                        >
                            <Option value="errorbars">Show Errorbars</Option>
                            <Option value="maintenance-events">Show Events</Option>
                        </Select>
                    </InputGroup>
                </Col>
            </Row>
        );
    }
}

export default ( Settings );


// WEBPACK FOOTER //
// ./src/components/Settings/Settings.js